export default __webpack_public_path__ + "static/media/city.b76f7a03.png";